import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User viewed a canvas',
  name: 'canvas_viewed',
  params: [
    {
      description: 'The id of the canvas',
      name: 'canvas_id',
      required: true,
      type: 'string',
    },
    {
      description: "The viewer's relationship to the canvas",
      name: 'viewer_role',
      required: true,
      type: 'enum',
      values: ['owner', 'workspace_member', 'anonymous'],
    },
    {
      description: 'The id of the board the canvas belongs to',
      name: 'board_id',
      required: false,
      type: 'string',
    },
    {
      description: 'Where the canvas was viewed from',
      name: 'viewed_from',
      required: false,
      type: 'enum',
      values: ['board', 'recent_canvases', 'my_canvases', 'all_canvases', 'shared_link'],
    },
  ],
};

export default META;
